export enum ReplenishmentTableColumn {
  Warning = "warning",
  PackageName = "packageName",
  ColorCode = "colorCode",
  SkuId = "replenishmentSkuId",
  SourceLocation = "warehouseName",
  DestinationLocation = "storeName",
  StoreId = "storeExternalId",
  Block = "block",
  ChangesDueBy = "changesDueBy",
  PlannedDeliveryDate = "plannedDeliveryDate",
  InventoryPosition = "position",
  DaysOfStock = "daysOfStock",
  StockStatus = "replenishmentStockStatus",
  SuggestedQuantity = "recommendedQuantity",
  UnrestrictedSuggestion = "unrestrictedSuggestion",
  MinDisplayQty = "minDisplayQty",
  MaxQty = "maxQty",
  OrderMultiple = "orderMultiple",
  StoreSalesL7 = "skuSales.l7",
  StoreSalesL14 = "skuSales.l14",
  StoreSalesWindow = "skuSales.window",
  RateOfSaleWindow = "rateOfSale",
  ExpectedSalesNext7Days = "expectedSalesNext7Days",
  RosBasis = "rosBasis",
  RosFallbackLevel = "rosFallbackLevel",
  DaysWithInventory = "daysWithInventory",
  VariantSalesL7 = "variantSales.l7",
  VariantRateOfSale = "variantRos",
  SkuShareOfVariant = "skuShareOfVariant",
  LocationStockOnHand = "storeStock",
  InTransit = "inTransit",
  WarehouseAvailable = "dcStock",
  WarehouseFreeStock = "freeStock",
  WarehouseEndBalance = "endBalance",
  BlockBalance = "blockBalance",
  NetworkStock = "networkStock",
  ValueAtRetail = "valueAtRetail",
  ValueAtCost = "valueAtCost",
  OverrideQuantity = "override",
  FinalQuantity = "effective",
  Included = "on",
}
